import { useForm } from 'react-hook-form';
import { ClinicProduct } from '../../../apis/clinic-products/types';
import { yupResolver } from '@hookform/resolvers/yup';
import Yup from '../../../utils/yup';

const useClinicProductsForm = (defaultValues?: ClinicProduct[] | null) => {
  return useForm<ClinicProduct[]>({
    defaultValues: defaultValues || [],
    resolver: yupResolver(schema)
  });
};

const virtualProductSchema = Yup.object().shape({
  clinic_price: Yup.number().required().min(0),
  clinic_fee: Yup.number().default(0).min(0),
  pharmacy_fee: Yup.number().default(0).min(0),
  is_active: Yup.boolean().default(false).required(),
  promotion: Yup.string().nullable(),
  course_length: Yup.string().nullable(),
  price_per_usage: Yup.string().nullable(),
  fixed_cycle: Yup.boolean().nullable(),
  cycle_length: Yup.number().when('fixed_cycle', (fixed_cycle, schema) => {
    return typeof fixed_cycle === 'boolean' ? schema.required() : schema.nullable();
  })
});

const schema = Yup.array()
  .of(virtualProductSchema)
  .min(1, 'This master medicine has no virtual medicines.');

export default useClinicProductsForm;
